import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input"]
  
  connect() {
    this.timeout = null
    this.lastValue = this.inputTarget.value
  }

  disconnect() {
    if (this.timeout) {
      clearTimeout(this.timeout)
    }
  }

  debouncedSubmit() {
    // Clear existing timeout
    if (this.timeout) {
      clearTimeout(this.timeout)
    }

    const currentValue = this.inputTarget.value
    
    // Only submit if value actually changed
    if (currentValue === this.lastValue) {
      return
    }

    // Debounce for 800ms to avoid too many refreshes
    this.timeout = setTimeout(() => {
      this.lastValue = currentValue
      
      // Store cursor position
      const cursorPosition = this.inputTarget.selectionStart
      const inputId = this.inputTarget.id
      
      // Submit the form
      this.element.requestSubmit()
      
      // Restore focus and cursor position after Turbo completes
      setTimeout(() => {
        const input = document.getElementById(inputId) || this.inputTarget
        if (input) {
          input.focus()
          input.setSelectionRange(cursorPosition, cursorPosition)
        }
      }, 100)
    }, 800)
  }
  
  // Allow immediate submit on Enter key
  submitOnEnter(event) {
    if (event.key === 'Enter') {
      if (this.timeout) {
        clearTimeout(this.timeout)
      }
      this.element.requestSubmit()
    }
  }
}